/* eslint-disable camelcase */
import { Divider, Input, Show, Stack } from '@chakra-ui/react';
import { memo } from 'react';
import { useStatsigClient } from '@statsig/react-bindings';

import { useInitiatives } from '@services/query-services/initiatives.query-service';
import { useFeedPageFilters } from '@util/hooks';
import { useUserStore } from '@store/app.store';
import ForaBanner from '@components/general/fora-banner.component';
import CustomSelect from '@components/general/form/custom-select.component';
import FilterItem from '@components/feed/feed-filter-item.component';

function FeedFilterAccordion() {
  const { checkGate } = useStatsigClient();
  const enableLabels = checkGate('labels');

  const user = useUserStore((state) => state?.user);
  const tenant = useUserStore((state) => state.tenant);
  const isGuest = user?.isGuest;
  const { filters, handleFilterChange } = useFeedPageFilters();

  const { data: allLabels } = useInitiatives(
    {
      type: 'Label',
      has_archived_at: false,
      tenant_id: tenant?.id,
      pageSize: 100
    },
    { enabled: !!(user && !isGuest) }
  );

  return (
    <Stack gap={4}>
      <FilterItem text='Keyword'>
        <Input
          size='sm'
          w='full'
          fontSize='sm'
          h={10}
          value={filters.keyword}
          onChange={(e) => handleFilterChange('keyword', e.target.value)}
          borderRadius='md'
          placeholder='Enter a keyword'
          _placeholder={{
            color: 'surface.outline',
            p: 0.5,
            ml: 1,
            textStyle: 'body-500-sm'
          }}
        />
      </FilterItem>
      {enableLabels && !isGuest && (
        <FilterItem text='Labels'>
          <CustomSelect
            size='md'
            selectProps={{ width: '100%' }}
            placeholder='Type or select a label'
            options={allLabels}
            getOptionLabel={(opt) => opt?.title}
            getOptionValue={(opt) => opt?.id}
            onChange={(e) => {
              handleFilterChange(
                'labels',
                e.map((label) => label?.id)
              );
            }}
            value={allLabels?.filter((label) => filters?.labels?.includes(label?.id))}
            menuPlacement='auto'
          />
        </FilterItem>
      )}

      {isGuest && (
        <Show above='lg'>
          <Divider mb={25} />
          <ForaBanner />
        </Show>
      )}
    </Stack>
  );
}

export default memo(FeedFilterAccordion);
